import {useEffect, useRef, useState} from "react";
import {Button, CircularProgress} from "@mui/material";
import {AddAPhoto, ArrowUpward, Delete} from "@mui/icons-material";
import Box from "@mui/material/Box";
import SlideFileCustom from "../../../../../../../material/file/SlideFileCustom";
import FileData from "../../../../../../../material/file/FileData";
import isNull from "../../../../../../../mixin/isNull";
import useHelper from "../../../../../../../use/useHelper";
import useAlert from "../../../../../../../use/useAlert";
import useDocumentRepository from "../../../../../../../repository/insurance/useDocumentRepository";
import PopperWrapper from "../../../../../../../material/popper/PopperWrapper";
import useEventDispatcher from "../../../../../../../use/useEventDispatcher";
import parameter from "../../../../../../../enum/parameter";
import Compressor from "compressorjs";

export default function ({onChange}) {
    const alert = useAlert();
    const eventDispatcher = useEventDispatcher();
    const helper = useHelper();
    const documentRepository = useDocumentRepository();
    const pictureInput = useRef();
    const uploadButtonRef = useRef();
    const [pictures, setPictures] = useState([]);
    const [currentIndex, setCurrentIndex] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        eventDispatcher.launcher("first-insurance-picture");
    }, []);

    useEffect(() => {
        onChange(pictures);
    }, [pictures.length]);

    const handleAddPictureClicked = () => pictureInput.current.click();

    const handleUpload = async e => {
        setLoading(true);

        if (e.target.files.length === 0) {
            setLoading(false);
            return;
        }

        let initialCount = pictures.length;

        for (let i = 0; i < e.target.files.length; i++) {
            const file = e.target.files[i];

            new Compressor(file, {
                quality: 0.3,
                success: async compressedBlob => {
                    const fileId = await documentRepository.uploadFile(compressedBlob);

                    if (isNull(fileId)) {
                        alert.error("Échec de l'upload de la photo.");
                        setLoading(false);
                        return;
                    }

                    const preview = await helper.inputFileToRequestFile(compressedBlob);

                    setPictures(prevState => ([...prevState, {fileId, ...preview}]));
                    setLoading(false);
                },
                error: () => {
                    setLoading(false);
                }
            });

            initialCount++;
        }

        if (initialCount === 1) {
            eventDispatcher.launcher("more-than-one-insurance-picture");
        }
    }

    const handleDelete = () => {
        setPictures([...pictures.filter((pb, i) => i != currentIndex)]);
    }

    const getFile = async index => {
        const file = pictures[index];
        return new FileData("picture", file.content, file["content-type"]);
    }

    return (
        <>
            <Box display="flex" justifyContent={"center"}>
                <PopperWrapper
                    elementRef={uploadButtonRef}
                    placement={"bottom"}
                    content={"Prenez votre deuxième photo"}
                    triggeringEvent={"more-than-one-insurance-picture"}
                    autoCloseAfter={parameter.POPUP_TIME}
                    displayCloseButton={false}
                    contentColor={parameter.POPUP_COLOR}
                    icon={<ArrowUpward color={parameter.POPUP_COLOR}/>}
                />
                <PopperWrapper
                    elementRef={uploadButtonRef}
                    placement={"bottom"}
                    content={"Prenez votre première photo"}
                    triggeringEvent={"first-insurance-picture"}
                    autoCloseAfter={parameter.POPUP_TIME}
                    displayCloseButton={false}
                    contentColor={parameter.POPUP_COLOR}
                    icon={<ArrowUpward color={parameter.POPUP_COLOR}/>}
                />
                <Button
                    variant="contained"
                    size="small"
                    startIcon={loading ? <CircularProgress size={20} color={"inherit"}/> : <AddAPhoto/>}
                    sx={{width: "80%"}}
                    onClick={handleAddPictureClicked}
                    disabled={loading}
                    ref={uploadButtonRef}
                    data-test="insurance-button-picture"
                >
                    {!loading ? "Prendre une photo" : "Upload en cours"}
                </Button>
                <input
                    ref={pictureInput}
                    style={{display: "none"}}
                    type={"file"}
                    accept="image/*"
                    onChange={handleUpload}
                    data-test="insurance-input-file"
                    multiple
                />
            </Box>
            <Box mt={5}>
                {
                    !isNull(currentIndex)
                        ? (
                            <Box
                                display="flex"
                                justifyContent="end"
                                mb={3}
                                mr={2}
                            >
                                <Button
                                    variant="contained"
                                    size="small"
                                    startIcon={<Delete/>}
                                    color={"error"}
                                    onClick={handleDelete}
                                >
                                    Supprimer
                                </Button>
                            </Box>
                        )
                        : null
                }
                <SlideFileCustom
                    key={pictures.length}
                    ids={pictures.map((pb, i) => i)}
                    getFile={getFile}
                    startAtIndex={pictures.length - 1}
                    disableDownload={true}
                    onChange={setCurrentIndex}
                />
            </Box>
        </>
    )
}
